import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { ThemeService } from '../service/theme.service';
import { IotService } from '../service/iot.service';
import { SleepTime } from '../constants/sleep-time';
import { SystemMessageService } from '../service/system-message.service';
import { CognitoService } from '../service/cognito.service';
import { firstValueFrom } from 'rxjs';

@Component({
    selector: 'app-device-modal-config',
    templateUrl: './device-modal-config.component.html',
    styleUrls: ['../../global-elements.css', '../iot/iot.css', './device-modal-config.component.css'],
    standalone: false
})
export class DeviceModalConfigComponent implements OnInit{

  // Variable that take the constant
  public sleepTime = SleepTime;

  public active: number = 0;

  // Variables used in the validation of the update
  public tempIsNumber: boolean = false;
  public tempIsTooLow: boolean = false;
  public submitClick: boolean = false;
  public changeSaved: boolean = false;
  public enableUpdate: boolean = false;
  public thingGroups: any[] = [];
  public selectedDeviceGroup:string = '';
  public checkBoxValue: number = 0;

  // Variable that take the shadow object
  public thingShadow: any;
  public updatedThingShadow: any;
  public selectedShadow: any;
  public currentDevice:any;
  // Message displayed to the user
  private systemMessage: string = '';
  public disabledOption:string = '';
  public uptLibraries: boolean = false;
  public getThemeClass: boolean = true;

  public desiredFirmwareVersion: string = '';
  @Output() deviceGroupChangeEvent = new EventEmitter<{
  newGroup: string;
}>();
  currentFirmwareVersion: any;

  constructor(public theme: ThemeService,
              public iotService: IotService,
              private systemMessageService: SystemMessageService,
              public cognitoService: CognitoService){

  }

  async ngOnInit() {
    await this.getFirmwareList();
    await this.cognitoService.getUserType();

    this.resetVariables();
    const shadowState = this.iotService.thingShadow?.state;
    this.currentFirmwareVersion = shadowState?.reported?.dat?.fdv || '';
    this.desiredFirmwareVersion = shadowState?.desired?.config?.fwv || '';
    try {
      // Attempt to get a list of thing groups from the IoT service.
      const data = await this.iotService.getThingGroups();
      // Extract the group names and store them in the thingGroups array.
      this.thingGroups = data?.thingGroups?.map((item: any) => item.groupName) || [];
      this.currentDevice = this.iotService.devicesArray.find((d:any) =>{
        return d.thingName === this.iotService.thingName
      })
      let group =  await this.iotService.getThingGroupsForThing(this.iotService.thingName)
    this.disabledOption = group[0];
      this.selectedDeviceGroup = this.disabledOption;
    } catch (error) {
      // Handle errors if they occur when fetching thing groups.
      console.error('Error fetching thing groups:', error);
    }
  }

  // Function called went user click on cancel button of the modal
  cancel(){
    // Set the showDeviceConfigModal = false so it will hide the modal
    this.iotService.showDeviceConfigModal = false;
  }

  // Function called when user click the confirm button
  async onSubmit(){

    sessionStorage.setItem('device-config-modal', 'alert-success-generic-message');
    // Set his own thingShadow to be able to compare whit the updated one after change have been made
    // this.iotService.thingShadow.state.desired.config.fwv = this.iotService.thingShadow.state.desired.config.firmwareVrsion;
    this.thingShadow = this.iotService.thingShadow;

    this.thingShadow.state.desired.config.ulib = this.uptLibraries ? 1 : 0

    this.resetVariables(); // Reset the variable for the validation
    // Set the variable submitClick at true, used in HTML alert
    this.submitClick = true;

    // Get the temperature input  in the DOM
    const temperatureInput = document.getElementsByClassName('hibernationTemp')[0] as HTMLInputElement;
    if(temperatureInput){ // Look if there is an input
      // We want to know if the input can be a number because a temperature is a number
      if(!isNaN(parseInt(temperatureInput.value))){
        // If it is, set the variable to true so we know that temperature is a number
        this.tempIsNumber = true;

        // Check if the temperature set by user is not under -45 so we avoid breaking the device whit too cold temperature
        if(parseInt(temperatureInput.value) < -45){
          // Set the system message
          this.systemMessage = 'deviceConfigModalAlertTempTooLow';
        }else{
          // If temperature is higher then -45
          this.tempIsTooLow = false;
        }
      }else{
        // Set the system message
        this.systemMessage = 'deviceConfigModalAlertTempNotNumber';
      }
    }

    // If the two temperature condition are met, we can update the shadow
    if(this.tempIsNumber && !this.tempIsTooLow){
      // Delete the delta from the shadow because the update function doesn't take the delta
      delete this.iotService.thingShadow.state.delta;
      // Update the shadow
      await this.iotService.updateThingShadow(this.iotService.thingName, this.iotService.thingShadow);
    }
    // I=selected  group differs from device original group
    if(this.selectedDeviceGroup != this.disabledOption){
      //updates device group
      console.log('[DEBUG] switching device ', this.iotService.thingName, 'from group ', this.disabledOption, 'to group ', this.selectedDeviceGroup );
      await  this.iotService.changeThingGroup(this.iotService.thingName, this.disabledOption,this.selectedDeviceGroup )
        // Emit change event
        this.deviceGroupChangeEvent.emit({
          newGroup:this.selectedDeviceGroup ,
        });
    }

    // Set a new instance of the new thingShadow to be able to compare whit the old
    this.updatedThingShadow = await this.iotService.getDeviceShadow(this.iotService.thingName);

    // Take the new shadow of the device and the one that we just pass to see if they are the same and if so we set the variable shadowUpdated at true
    for(const key in this.updatedThingShadow.state.desired.config){
      // If the key match and are equal we set the variable to true
      if(this.updatedThingShadow.state.desired.config[key] === this.thingShadow.state.desired.config[key]){
        this.iotService.shadowUpdated = true;
      }else{
        // If the key match but are not equal, set the variable to false then break to avoid the variable to be true
        this.iotService.shadowUpdated = false;
        break;
      }
    }

    // Check if the shadow updated variable is set to true
    if(this.iotService.shadowUpdated){
      // Hide the modal
      this.iotService.showDeviceConfigModal = false;

      // Call a function to made a log of the change in DB
      this.updateShadowLog()

      // Set the variable that iot component used in html to show the success message
      this.iotService.shadowSuccessUpdated();
    }else{
      // If system message have nothing it put a generic message
      if(this.systemMessage === ''){
        this.systemMessage = 'alert-danger-generic-message';
      }
      // Set the system message service to display the error to the user
      this.systemMessageService.selectRibbon('danger', this.systemMessage);
    }
  }

  // Function called to reset the validation variables
  resetVariables(){
    this.tempIsNumber = false;
    this.tempIsTooLow = false;
    this.iotService.shadowUpdated = false;
  }

  // Function called to made and update log in DB
  updateShadowLog(){
    // Get the id of the current user that will do the change on the shadow
    const userSubPromise = this.cognitoService.getCurrentUserSub();
    userSubPromise.then((userSub) => {
      // Get the current date and set it to the proper format the put it into DB
      const date = new Date();
      const timestamp = date.getTime();

      // Call the function that write the log in DB
      const result = this.iotService.updateShadowDBLog(userSub, timestamp);
    });
  }

  // Function that will put different style to the page depend on his user type and width
  getDisplayByUserType(){
    const screenWidth = window.innerWidth;

    // Style for user type Muirwood and screen under 930 px
    if(this.cognitoService.userType === 'muirwood' && screenWidth < 930){
      return {
        'display': 'block',
        'position': 'fixed',
        'width': '450px',
        'height': '600px',
        'padding': '15px',
        'top': '50%',
        'left': '50%',
        'transform': 'translate(-50%, -50%)',
        'box-shadow': '2px 3px 3px 2px gray',
        'z-index': '50',
        'margin': 'auto',
        'border-radius': '5px',
        'border': '1px solid gray'
      }
    }
    // Style for user type Muirwood and screen over 930 px
    if(this.cognitoService.userType === 'muirwood' && screenWidth >= 930){
      return {
        'display': 'block',
        'position': 'fixed',
        'width': '750px',
        // 'height': '600px',
        // 'top': '15%',
        'box-shadow': '2px 3px 3px 2px gray',
        'z-index': '10',
        'padding': '15px',
        'border-radius': '5px',
        'border': '1px solid gray',
        'top': '50%',
        'left': '50%',
        'transform': 'translate(-50%, -50%)'
        }
    }
    // For all other user type
    if(this.cognitoService.userType !== 'muirwood'){
      return {
        'display': 'block',
        'position': 'fixed',
        'width': '450px',
        'height': '420px',
        'padding': '15px',
        'top': '50%',
        'left': '50%',
        'transform': 'translate(-50%, -50%)',
        'box-shadow': '2px 3px 3px 2px gray',
        'z-index': '50',
        'margin': 'auto',
        'border-radius': '5px',
        'border': '1px solid gray'
      }
    }else{
      return {
        'display': 'none'
      }
    }
  }

  async getFirmwareList() {
    try {
      // Use the clientService to fetch client data from an API
      await firstValueFrom(this.iotService.getFirmwareVersions()).then((response)=>{
        // Successful response callback
        this.iotService.firmwareVersionArray = response;
      })
    } catch (error) {
      console.error("Error: ", error);
    }
  }

  get filteredFirmwareVersions() {
    const current = this.iotService.thingShadow.state.desired.config.fwv;
    return this.iotService.firmwareVersionArray
      ? this.iotService.firmwareVersionArray.filter(fw => fw.version !== current)
      : [];
  }

  firmwareChange(event: any): void{
    const selectedVersion = event;
    const chkBox = document.getElementById("enableUpdateCheckbox") as HTMLInputElement;

    if (!chkBox) return;

    const confirmed = confirm(
      "You’re about to change the firmware version of that device. The device will update to this version on the next boot. Proceed with caution. Continue?"
    );
    if (confirmed) {
        this.desiredFirmwareVersion = selectedVersion;
        this.iotService.thingShadow.state.desired.config.fwv = selectedVersion;
    }
    else{
      this.desiredFirmwareVersion = this.iotService.thingShadow.state.desired.config.fwv
    }
    chkBox.checked = false;
    this.enableUpdate = false;
}

  // Function to manage the check box of the enable update feature,
  // this is require if we want a confirm()
  toggleEnableUpdate(event: any){
    event.preventDefault();
    if (!this.enableUpdate &&
      !confirm("You’re about to toggle a feature that may impact device stability. Proceed with caution. Continue?")) {
      event.target.checked = false;
      return;
    }
    this.enableUpdate = !this.enableUpdate;
    event.target.checked = this.enableUpdate;
  }
}
